import { render, staticRenderFns } from "./flash-messages-list.vue?vue&type=template&id=c6297210&"
import script from "./flash-messages-list.vue?vue&type=script&lang=ts&"
export * from "./flash-messages-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports